import { render, staticRenderFns } from "./OpenOrder.vue?vue&type=template&id=017867f8&scoped=true"
import script from "./OpenOrder.vue?vue&type=script&lang=js"
export * from "./OpenOrder.vue?vue&type=script&lang=js"
import style0 from "./OpenOrder.vue?vue&type=style&index=0&id=017867f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017867f8",
  null
  
)

export default component.exports